"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireWildcard(require("immutable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _generalStore = require("general-store");

var _EmailInteractionEventTypes = require("customer-data-communicator/schema/interactions/email/EmailInteractionEventTypes");

var _GlobalInteractionEventTypes = require("customer-data-communicator/schema/interactions/GlobalInteractionEventTypes");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _UserSettingsKeys = require("crm_data/settings/UserSettingsKeys");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var LocalSettings = _interopRequireWildcard(require("crm_data/settings/LocalSettings"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _Communicator = _interopRequireDefault(require("customer-data-communicator/components/Communicator"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _connectRte = _interopRequireDefault(require("crm_ui/draftjs/connectRte"));

var _EngagementAssociationActions = require("crm_ui/engagementAssociations/actions/EngagementAssociationActions");

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _loggers = require("customer-data-tracking/loggers");

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _InteractionConfig = _interopRequireDefault(require("./config/InteractionConfig"));

var _InteractionTypesConfig = _interopRequireDefault(require("./config/InteractionTypesConfig"));

var _EmailUsageTracking = require("./types/email/EmailUsageTracking");

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _InteractionTypesType = _interopRequireDefault(require("customer-data-communicator/schema/interactions/InteractionTypesType"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _TwilioClientStore = _interopRequireDefault(require("TwilioUI/flux/TwilioClientStore"));

var StatusGroup = _interopRequireWildcard(require("TwilioUI/js/utils/statusGroups"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _PortalStore = _interopRequireDefault(require("crm_data/portal/PortalStore"));

var propTypes = {
  defaultInteraction: _InteractionTypesType.default,
  gates: _reactImmutableProptypes.default.setOf(_propTypes.default.string),
  objectType: _ProfileObjectTypesType.default.isRequired,
  ownerId: _propTypes.default.number.isRequired,
  teamId: _propTypes.default.number,
  query: _propTypes.default.object,
  subject: _SubjectType.default,
  subjectId: _propTypes.default.string.isRequired,
  isFullScreen: _propTypes.default.bool,
  isMinimized: _propTypes.default.bool,
  handleToggleMinimize: _propTypes.default.func,
  handleCloseCommunicator: _propTypes.default.func.isRequired,
  twilioClient: _reactImmutableProptypes.default.map
};

var ProfileCommunicatorContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProfileCommunicatorContainer, _Component);

  function ProfileCommunicatorContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileCommunicatorContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileCommunicatorContainer).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ProfileCommunicatorContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !this.props.subject || this.props.isMinimized !== nextProps.isMinimized || this.props.isFullScreen !== nextProps.isFullScreen || this.props.defaultInteraction !== nextProps.defaultInteraction || this.props.subject && nextProps.subject && !_immutable.default.is(this.props.subject.properties, nextProps.subject.properties);
    }
  }, {
    key: "hasCommunicatePermissions",
    value: function hasCommunicatePermissions() {
      return (0, _SubjectPermissions.canCommunicate)(this.props.subject) || this.props.defaultInteraction === 'note' || this.props.defaultInteraction === 'task';
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(type) {
      var query = this.props.query;

      var _links$getQueryParams = _links.default.getQueryParams(),
          currentQueryParams = _links$getQueryParams.currentQueryParams;

      var params = (0, _extends2.default)({}, currentQueryParams, query, {
        interaction: type
      });

      _links.default.setQueryParam({
        queryString: _links.default.toQueryString(params),
        navigationOptions: {
          trigger: false,
          replace: true
        }
      });
    }
  }, {
    key: "dispatchSignatureChanged",
    value: function dispatchSignatureChanged(_ref) {
      var sender = _ref.sender,
          signature = _ref.signature;
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.EMAIL_ALIAS_SIGNATURE_UPDATED, {
        emailAddressId: sender.from.addressId,
        signature: signature
      });
    }
  }, {
    key: "trackCommunicatorInteraction",
    value: function trackCommunicatorInteraction(action) {
      var defaultInteraction = this.props.defaultInteraction;

      _loggers.CommunicatorLogger.log('communicatorInteraction', {
        action: action,
        activity: defaultInteraction,
        channel: defaultInteraction === 'call' ? 'outbound call' : defaultInteraction,
        source: 'communicator'
      });
    }
  }, {
    key: "handleInteractionTypeChanged",
    value: function handleInteractionTypeChanged(type) {
      var _this$props = this.props,
          subjectId = _this$props.subjectId,
          objectType = _this$props.objectType;
      this.updateUrl(type);
      (0, _EngagementAssociationActions.clearAssociations)(objectType, Number(subjectId));
    }
  }, {
    key: "handleInteractionEvent",
    value: function handleInteractionEvent(event, data) {
      switch (event) {
        case _EmailInteractionEventTypes.EMAIL_SEND_SUCCEEDED:
          {
            (0, _EmailUsageTracking.handleEmailSent)(data);
            break;
          }

        case _EmailInteractionEventTypes.EMAIL_SEND_FAILED:
          {
            (0, _Alerts.addError)(data.error.message, data.error.options);
            break;
          }

        case _EmailInteractionEventTypes.EMAIL_ALIAS_SIGNATURE_CHANGED:
          {
            this.dispatchSignatureChanged(data);
            break;
          }

        case _EmailInteractionEventTypes.EMAIL_TRACKING_TOOLTIP_DISMISSED:
          {
            (0, _UserSettingsActions.saveUserSetting)(_UserSettingsKeys.EMAIL_COMMUNICATOR_TRACKING_TOOLTIP_SHOWN, true);
            break;
          }

        case _EmailInteractionEventTypes.EMAIL_SEND_WITH_BRANDING_BANNER:
          {
            (0, _EmailUsageTracking.handleEmailSentWithBrandingBanner)();
            break;
          }

        case _GlobalInteractionEventTypes.INITIAL_COMMUNICATOR_CONTENT_ENTRY:
          {
            _loggers.CrmLogger.logRecordInteraction(this.props.objectType, {
              action: 'communicator interaction',
              subAction: "start to type " + data.interactionType.toLowerCase()
            });

            break;
          }

        case _GlobalInteractionEventTypes.FLOATING_COMMUNICATOR_EXPAND_FULLSCREEN:
          {
            _loggers.CrmLogger.log('communicatorFullScreenInteraction', {
              action: 'expand to full screen',
              type: data.type
            });

            break;
          }

        case _GlobalInteractionEventTypes.FLOATING_COMMUNICATOR_FULLSCREEN_SAVE:
          {
            _loggers.CrmLogger.log('communicatorFullScreenInteraction', {
              action: 'save engagement in full screen',
              type: data.type
            });

            break;
          }

        default:
          {
            break;
          }
      }
    }
  }, {
    key: "handleCloseCommunicator",
    value: function handleCloseCommunicator(type) {
      var handleCloseCommunicator = this.props.handleCloseCommunicator;
      (0, _CommunicatorActions.hideCommunicator)(type); // remove interaction query param

      this.updateUrl(null);

      if (typeof handleCloseCommunicator === 'function') {
        handleCloseCommunicator();
      }
    }
  }, {
    key: "handleCallInProgressUsageLogging",
    value: function handleCallInProgressUsageLogging(subAction) {
      if (StatusGroup.isCallInProgress(this.props.twilioClient.get('status'))) {
        _loggers.CrmLogger.logRecordInteraction(this.props.objectType, {
          action: 'communicator interaction',
          subAction: subAction
        });
      }
    }
  }, {
    key: "handleNavigationTriggered",
    value: function handleNavigationTriggered() {
      this.handleCallInProgressUsageLogging('navigated page when call in progress');
    }
  }, {
    key: "handleToggleMinimize",
    value: function handleToggleMinimize() {
      if (this.props.isMinimized) {
        (0, _CommunicatorActions.maximizeCommunicator)();
      } else {
        this.handleCallInProgressUsageLogging('minimized communicator when call in progress');
        this.trackCommunicatorInteraction('minimize');
        (0, _CommunicatorActions.minimizeCommunicator)();
      }
    }
  }, {
    key: "handleToggleFullScreen",
    value: function handleToggleFullScreen(type) {
      if (this.props.isFullScreen) {
        (0, _CommunicatorActions.closeFullScreenCommunicator)();
      } else {
        (0, _CommunicatorActions.openFullScreenCommunicator)();
        this.trackCommunicatorInteraction('expand');
        this.handleInteractionEvent(_GlobalInteractionEventTypes.FLOATING_COMMUNICATOR_EXPAND_FULLSCREEN, {
          type: type
        });
      }
    }
  }, {
    key: "handleUsageLogging",
    value: function handleUsageLogging(eventName, data) {
      _loggers.CrmLogger.log(eventName, (0, _extends2.default)({
        action: 'communicator interaction'
      }, data));
    }
  }, {
    key: "handlePasteContent",
    value: function handlePasteContent() {
      this.trackCommunicatorInteraction('paste text');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          subject = _this$props2.subject,
          isFullScreen = _this$props2.isFullScreen,
          isMinimized = _this$props2.isMinimized,
          defaultInteraction = _this$props2.defaultInteraction,
          objectType = _this$props2.objectType,
          gates = _this$props2.gates;

      if (!subject || !this.hasCommunicatePermissions()) {
        return null;
      }

      return _react.default.createElement(_Communicator.default, (0, _extends2.default)({}, this.props, {
        defaultInteraction: defaultInteraction,
        gates: gates,
        isFullScreen: isFullScreen,
        isMinimized: isMinimized,
        subject: subject,
        InteractionConfig: _InteractionConfig.default,
        interactionDescriptors: _InteractionTypesConfig.default,
        onInteractionTypeChanged: this.handleInteractionTypeChanged,
        onInteractionEvent: this.handleInteractionEvent,
        LocalSettings: LocalSettings,
        connectRte: _connectRte.default,
        handleCloseCommunicator: this.handleCloseCommunicator,
        handleToggleFullScreen: this.handleToggleFullScreen,
        handleToggleMinimize: this.handleToggleMinimize,
        handleUsageLogging: this.handleUsageLogging,
        onPasteContent: this.handlePasteContent,
        gdprDisabled: objectType === _ObjectTypes.TICKET,
        handleNavigationTriggered: this.handleNavigationTriggered
      }));
    }
  }]);
  return ProfileCommunicatorContainer;
}(_react.Component);

var dependencies = {
  subject: _SubjectDependency.default,
  twilioClient: _TwilioClientStore.default,
  gates: {
    stores: [_PortalStore.default],
    deref: function deref() {
      return (0, _immutable.Set)(_PortalStore.default.get().enabled_gates);
    }
  }
};
ProfileCommunicatorContainer.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(ProfileCommunicatorContainer);

exports.default = _default;
module.exports = exports.default;